import dp from './images/image-victor.jpg';
import cardImage from './images/bg-pattern-card.svg';
import './App.scss';

function App() {
  return (
    <article className='profile-card'>
      <section className='pc-img'>
        <img src={ cardImage } alt=''/>
      </section>
      <section className='pc-dp'>
        <img src={ dp } alt=''/>
      </section>

      <section className='pc-info'>
        <h1>Victor Crest<span> 26</span></h1>
        <p>London</p>
      </section>
      <hr></hr>
      <section className='pc-flp'>
        <div className='pc-flp-item'>
          <h2>80K</h2>
          <span>Followers</span>
        </div>
        <div className='pc-flp-item'>
          <h2>803K</h2>
          <span>Likes</span>
        </div>
        <div className='pc-flp-item'>
          <h2>1.4K</h2>
          <span>Photos</span>
        </div> 
      </section>
    </article>
  );
}

export default App;


